define('MultipleAddToCartPLP.Cart.Confirmation.Line.View', [
    'Backbone',
    'multipleaddtocartplp_confirmation_line.tpl',
    'Backbone.CompositeView',
    'Transaction.Line.Views.Options.Selected.View',
    'ProductLine.Sku.View',
    'Utils',
    'Transaction.Line.Views.Price.View'
], function MultipleAddToCartPLPCartConfirmationView(
    Backbone,
    multipleaddtocartplpConfirmationLineTpl,
    BackboneCompositeView,
    TransactionLineViewsOptionsSelectedView,
    ProductLineSkuView,
    Utils,
    TransactionLineViewsPriceView
) {
    'use strict';

    return Backbone.View.extend({

        template: multipleaddtocartplpConfirmationLineTpl,

        initialize: function initialize() {
            this.model.on('change', this.render, this);
            BackboneCompositeView.add(this);
        },

        destroy: function destroy() {
            this.model.off('change', this.render, this);
            this._destroy();
        },

        childViews: {
            'Line.Price': function LinePrice() {
                return new TransactionLineViewsPriceView({
                    model: this.model
                });
            },
            'Line.SelectedOptions': function LineSelectedOptions() {
                return new TransactionLineViewsOptionsSelectedView({
                    model: this.model
                });
            },
            'Line.Sku': function LineSku() {
                return new ProductLineSkuView({
                    model: this.model
                });
            }
        },

        getContext: function getContext() {
            var item = this.model.get('item');
            return {
                model: this.model,
                thumbnail: this.model.getThumbnail(),
                showQuantity: item.get('_itemType') !== 'GiftCert' && this.model.get('quantity') > 0,
                itemName: item.get('_name', true)
            };
        }
    });
});
